import { FirebaseProjectKey } from '../config/firebase-config';

export const slackClientId = (
  process.env.POP_ENV === 'dev' ? '2861940758.892692669632' : '2861940758.676555587008'
) as FirebaseProjectKey;
